import { Ability, Action, Subject } from '../ability';

class StorageStatsAbility implements Ability {
  subject: Subject;
  action: Action;

  constructor(action: Action) {
    this.subject = 'StorageStats';
    this.action = action;
  }
}
export const GetTotalStorageStats = new StorageStatsAbility(
  'totalStorage' as Action,
);
export const GetByDateStorageStats = new StorageStatsAbility(
  'byDateStorage' as Action,
);

export const storageStatsAbilities = [
  GetTotalStorageStats,
  GetByDateStorageStats,
];

export default storageStatsAbilities;
